import { CruisesContract as API, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'deal-crawlers';

export type CruiseDealCrawler = definitions['DEAL_CRAWLER'];
export type CruiseDealSailingCrawler = definitions['DEAL_SAILING_CRAWLER_WITH_DEPARTURE'];

const crawlDealPage = async (sourceUrl: string): Promise<CruiseDealCrawler> => {
  const response = await cruisesAPI.http.post<API.Response<CruiseDealCrawler>>({
    resource: `${resource}/crawl`,
    body: {
      sourceUrl,
    },
  });

  return response.result;
};

const listWithPagination = (
  paginationParams: API.PaginationParams,
  requestOptions?: { signal?: AbortSignal },
): Promise<API.Response<Array<CruiseDealCrawler>>> => {
  return cruisesAPI.http.get({ resource, paginationParams }, undefined, requestOptions);
};

const getById = (id: string, requestOptions?: { signal?: AbortSignal }): Promise<API.Response<CruiseDealCrawler>> => {
  return cruisesAPI.http.get({ resource: `${resource}/${id}` }, undefined, requestOptions);
};

const deleteById = (id: string): Promise<API.Response<CruiseDealCrawler>> => {
  return cruisesAPI.http.delete({ resource: `${resource}/${id}` });
};

const getSailings = (
  id: string,
  paginationParams?: API.PaginationParams,
  requestOptions?: { signal?: AbortSignal },
): Promise<API.Response<Array<CruiseDealSailingCrawler>>> => {
  return cruisesAPI.http.get(
    {
      resource: `${resource}/${id}/sailings`,
      paginationParams: paginationParams || {},
    },
    undefined,
    requestOptions,
  );
};

export default {
  crawlDealPage,
  listWithPagination,
  getById,
  deleteById,
  getSailings,
};
